import React, { Component } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Table, Button, message } from 'antd';
import { formatDate } from '@/utils/format';
import './myDiscount.less';

const clsPrefix = 'my-discount';

const columns = [{
  title: '折扣码',
  dataIndex: 'promoCode',
  width: 200,
}, {
  title: '折扣',
  dataIndex: 'discount',
  width: 80,
}, {
  title: '剩余次数',
  width: 80,
  render: (text, record) => {
    return record.maxCount - record.count
  }
}, {
  title: '有效期至',
  dataIndex: 'expireTime',
  width: 250,
  render: (expireTime) => {
    return formatDate(new Date(expireTime * 1000).toLocaleDateString());
  }
}, {
  title: '操作',
  render: (text, record) => {
        return (
          <CopyToClipboard text={record.promoCode} >
              <Button onClick={() => { message.success('复制成功'); }}>复制</Button>
          </CopyToClipboard>
        )
  }
}];


class MyDiscount extends Component{
  render() {
      return (
        <div className={clsPrefix}>
          <div className={`${clsPrefix}-title`}>我的折扣码：</div>
          {
            (this.props.discountList && this.props.discountList.length > 0) ?
              <div style={{ width: '600px', margin: 'auto' }}>
                <Table
                  columns={columns}
                  dataSource={this.props.discountList}
                  bordered
                  pagination={{
                    pageSize: 3,
                  }}
                />
              </div>
          : <div>
              <div className="no-discount-code"> 暂无折扣码</div>
            </div>
          }
        </div>
      );
  }
}
export default MyDiscount;
